module.exports = __webpack_public_path__ + "static/media/location_singapore@2x.94c5ed2b.png";